import { Button } from '@playbooks/ui/components/button';
import { Dialog, DialogContent } from '@playbooks/ui/components/dialog';
import { Icon } from '@playbooks/ui/components/icon';

import { TemplateBrowserPreview } from 'components/template/template-browser-preview';
import { TemplateMarketplaceDetails } from 'components/template/template-marketplace-details';
import { TemplateMarketplaceHeader } from 'components/template/template-marketplace-header';
import { useModal } from 'contexts';

const TemplatePreviewModal = () => {
	const modal = useModal();
	const hasPrevious = modal.index > 0;
	const hasNext = modal.index >= 0 && modal.index < modal.templates.length - 1;

	return (
		<Dialog open={modal.open} onOpenChange={nextOpen => !nextOpen && modal.closeTemplate()}>
			<DialogContent
				showCloseButton={false}
				className='h-[calc(100vh-2rem)] max-w-[calc(100vw-2rem)] gap-0 overflow-hidden bg-canvas p-0 sm:h-[min(76vh,48rem)] sm:max-w-6xl'>
				<div className='flex min-h-0 flex-1 flex-col rounded-panel border border-border bg-canvas'>
					<div className='border-b p-3'>
						<TemplateMarketplaceHeader template={modal.template} compact onClose={modal.closeTemplate} />
					</div>
					<div className='relative flex min-h-0 grow'>
						{modal.detailsOpen ? (
							<aside className='absolute inset-y-0 left-0 z-10 w-[min(22rem,85vw)] overflow-y-auto border-r bg-canvas p-4 md:static md:block md:w-72'>
								<TemplateMarketplaceDetails template={modal.template} sidebar />
							</aside>
						) : null}
						<div className='relative min-w-0 grow p-3'>
							<Button
								variant='outline'
								size='icon-xs'
								aria-label='Toggle project details'
								aria-pressed={modal.detailsOpen}
								onClick={() => modal.setDetailsOpen(!modal.detailsOpen)}
								className='absolute top-5 left-5 z-2'>
								<Icon icon='sidebar' aria-hidden />
							</Button>
							{modal.error ? (
								<div className='flex size-full items-center justify-center text-foreground-body'>
									We couldn't load this project.
								</div>
							) : (
								<TemplateBrowserPreview template={modal.template} compact className='h-full' />
							)}
						</div>
					</div>
				</div>
				{hasPrevious ? (
					<Button
						variant='outline'
						size='icon'
						aria-label='Previous project'
						onClick={modal.previousTemplate}
						className='fixed top-1/2 left-3 z-60 rounded-full'>
						<Icon icon='chevron-left' aria-hidden />
					</Button>
				) : null}
				{hasNext ? (
					<Button
						variant='outline'
						size='icon'
						aria-label='Next project'
						onClick={modal.nextTemplate}
						className='fixed top-1/2 right-3 z-60 rounded-full'>
						<Icon icon='chevron-right' aria-hidden />
					</Button>
				) : null}
			</DialogContent>
		</Dialog>
	);
};

export { TemplatePreviewModal };
